"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRestate = void 0;
const redux_1 = require("redux");
const ioc_container_1 = require("./ioc-container");
const EventEmitter = require("eventemitter3");
function invokeScopeOnInit(plugins, args) {
    plugins.forEach(p => {
        if (p.onScopeInit !== undefined) {
            p.onScopeInit(args);
        }
    });
}
function invokeStoreOnInit(plugins, args) {
    plugins.forEach(p => {
        if (p.onInit !== undefined) {
            p.onInit(args);
        }
    });
}
function invokePluginEvent(plugins, eventName, args) {
    plugins.forEach(p => {
        const eventHandler = p[eventName];
        if (eventHandler !== undefined) {
            eventHandler(args);
        }
    });
}
function invokeReducePluginEvent(plugins, eventName, args) {
    return plugins.reduce((newArgs, p) => {
        const eventHandler = p[eventName];
        if (eventHandler === undefined) {
            return newArgs;
        }
        return { ...newArgs, ...eventHandler(newArgs) };
    }, args);
}
function invokeBeforeThunkPluginEvent(plugins, args) {
    plugins.forEach((p) => {
        const eventHandler = p.onBeforeThunk;
        if (eventHandler === undefined) {
            return;
        }
        eventHandler(args);
    }, args);
}
function invokeAfterThunkPluginEvent(plugins, args) {
    return plugins.reduce((prevResult, p) => {
        const eventHandler = p.onAfterThunk;
        if (eventHandler === undefined) {
            return prevResult;
        }
        return eventHandler({ ...args, result: prevResult.result });
    }, { result: args.result });
}
function createRestate(options) {
    const { store, onBuildIocContainer = () => { return; }, plugins = [] } = options;
    const { dispatch, getState, replaceReducer, subscribe } = store;
    const scopeMap = new Map();
    const reducers = {};
    function getScope(scopeName) {
        return scopeMap.get(scopeName);
    }
    const eventEmitter = new EventEmitter();
    eventEmitter.on('onScopeInit', (args) => {
        invokeScopeOnInit(plugins, args);
    });
    eventEmitter.on('onBeforeDispatch', (args) => {
        invokePluginEvent(plugins, 'onBeforeDispatch', args);
    });
    eventEmitter.on('onAfterDispatch', (args) => {
        invokePluginEvent(plugins, 'onAfterDispatch', args);
    });
    eventEmitter.on('onBeforeReduce', (args) => {
        const updateArgs = invokeReducePluginEvent(plugins, 'onBeforeReduce', args);
        args.payload = updateArgs.payload;
        args.state = updateArgs.state;
        args.type = updateArgs.type;
    });
    eventEmitter.on('onAfterReduce', (args) => {
        const updateArgs = invokeReducePluginEvent(plugins, 'onAfterReduce', args);
        args.payload = updateArgs.payload;
        args.state = updateArgs.state;
        args.type = updateArgs.type;
    });
    eventEmitter.on('onBeforeThunk', (args) => {
        invokeBeforeThunkPluginEvent(plugins, args);
    });
    eventEmitter.on('onAfterThunk', (args) => {
        const updateArgs = invokeAfterThunkPluginEvent(plugins, args);
        args.result = updateArgs.result;
    });
    const builder = ioc_container_1.createIocContainerBuilder();
    onBuildIocContainer(builder);
    const iocContainer = builder.build();
    const restate = {
        addScope(scopeName, scopeCreator) {
            if (scopeMap.has(scopeName)) {
                return scopeMap.get(scopeName);
            }
            const scope = scopeCreator({
                dispatch,
                getScope,
                scopeName,
                iocContainer,
                eventEmitter,
                getState() {
                    const appState = getState();
                    return appState.scopes[scopeName];
                },
                setReducer(reducer) {
                    reducers[scopeName] = reducer;
                    const newReducer = redux_1.combineReducers({ scopes: redux_1.combineReducers(reducers) });
                    replaceReducer(newReducer);
                }
            });
            scopeMap.set(scopeName, scope);
            return scope;
        },
        getScope,
        removeScope(scopeName) {
            delete reducers[scopeName];
            const newReducer = redux_1.combineReducers({ scopes: redux_1.combineReducers(reducers) });
            replaceReducer(newReducer);
            scopeMap.delete(scopeName);
        },
        subscribe
    };
    invokeStoreOnInit(plugins, { builder, restate });
    return restate;
}
exports.createRestate = createRestate;
//# sourceMappingURL=store.js.map